import { useFormik } from "formik"
import { t } from "i18next"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router"
import { useHistory } from "react-router-dom"
import * as Yup from "yup"
import { toAbsoluteUrl } from "../../../../_metronic/_helpers/AssetsHelpers.js"
import { useHtmlClassService, useSubheader } from "../../../../_metronic/layout/index.js"
import { ILLUSTRATION_CONSTANTS } from "../../../../constants/ImageConstants.js"
import { FIELD_OFFICER, UPLOAD } from "../../../../constants/InitTypeConstants.js"
import { RoutesConstants } from "../../../../constants/RoutesConstants.js"
import {
  getDetailTargetByYearTargetRegional,
  getDetailTargetByYearTargetSubRegional,
  submitEditTargetRegional
} from "../../../../redux/actions/FieldOfficerAction.jsx"
import { resetUrlResponse, uploadAction } from "../../../../redux/actions/MasterDataAction.jsx"
import { getMinimumErrorNumber } from "../../../helpers/StringCollection.js"
import { KPI_GOAL_SETTING_TAB } from "../../../../constants/StringConstant.js"
export function useEditTargetRegionalPage() {
  const dispatch = useDispatch()
  const history = useHistory()
  const subHeader = useSubheader()
  const uiService = useHtmlClassService()

  const { year, regional } = useParams()
  const regionalId = regional
  const { MasterData, General, FieldOfficer } = useSelector((state) => state)
  const [urlDocument, setUrlDocument] = useState(null)
  const [fileAttachments, setFileAttachments] = useState([])
  const [documentUrl, setDocumentUrl] = useState()
  const [targetId, setTargetId] = useState()
  const [activeStep, setActiveStep] = useState(0)
  const [totalSumTargetSubRegional, setTotalSumTargetSubRegional] = useState([])

  const labelStep = [t("label_edit_target"), t("label_preview")]

  function checkLabel(idx) {
    switch (idx) {
      case 0:
        return "Padi"
      case 1:
        return "Jagung"
      default:
        return "Jagung produksi"
    }
  }
  
  useEffect(() => {
    if (!FieldOfficer?.kpiGoalInitDataEditSubRegional) return

    const result = FieldOfficer.kpiGoalInitDataEditSubRegional.reduce(
      (acc, item) => {
        acc[0] += item.target[0]?.value ?? 0
        acc[1] += item.target[1]?.value ?? 0
        acc[2] += item.target[2]?.value ?? 0
        return acc
      },
      [0, 0, 0]
    )

    setTotalSumTargetSubRegional(result)
  }, [FieldOfficer?.kpiGoalInitDataEditSubRegional])

  const validationSchema = () => {
    return Yup.object().shape({
      target: Yup.array().of(
        Yup.object().shape({
          planting_target: Yup.number()
            .typeError("Harus berupa angka yang valid")
            .integer("Tidak boleh menggunakan angka desimal")
            .test("is-not-zero", getMinimumErrorNumber(0), (val, ctx) => {
              const index = ctx?.options?.index
              if (index === 2) return true
              return val !== 0
            })
            .test("not-over-total", function (val) {
              const index = this.options.index
              const max = totalSumTargetSubRegional?.[index]
              if (val >= max) return true
              return this.createError({
                message: `Target kurang dari Total Sub Regional (${checkLabel(index)} ${max} Ha)`
              })
            })
            .required("Value harus diisi")
        })
      )
    })
  }

  useEffect(() => {
    uiService.setFullPage()
    return () => {
      uiService.setExitFullPage()
    }
  }, [])

  useEffect(() => {
    subHeader.setButton()
    return () => {
      formik.resetForm()
    }
  }, [])

  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      year: year,
      target: [],
      document_url: ""
    },
    onSubmit: () => {
      if (targetId) {
        setActiveStep(1)
      }
    }
  })

  function onSubmit() {
    const e = formik.values
    if (e) {
      const data = {
        document_url: e.document_url,
        year: parseInt(e.year),
        target: formik.values.target.map((v) => {
          return {
            id: v.plant_type_id,
            value: parseInt(v.planting_target)
          }
        })
      }
      dispatch(submitEditTargetRegional(targetId, data))
    }
  }

  function onRemoveFile() {
    setFileAttachments([])
    formik.setFieldValue("document_url", undefined)
  }

  useEffect(() => {
    if (General?.isFinishUpdateOrDelete && General?.actionInitType === FIELD_OFFICER.SUBMIT_TARGET)
      swal({
        text: t("messages_response_success_setting_target_regional"),
        icon: toAbsoluteUrl(ILLUSTRATION_CONSTANTS.SUCCESS_SETTING_TARGET)
      }).then(() => {
        history.push(RoutesConstants.FIELD_OFFICER.KPI_GOAL_SETTING(regionalId, KPI_GOAL_SETTING_TAB.THIS_YEAR, year))
      })
  }, [General?.isFinishUpdateOrDelete])

  useEffect(() => {
    if (MasterData.urlResponseUpload) {
      formik.setFieldValue("document_url", MasterData?.urlResponseUpload)
      return () => {
        dispatch(resetUrlResponse())
      }
    }
  }, [MasterData.urlResponseUpload])

  useEffect(() => {
    if (!FieldOfficer?.page?.target) return
    formik.setFieldValue("target", FieldOfficer?.page?.target)
    setTargetId(FieldOfficer?.page?.id)
    setDocumentUrl(FieldOfficer?.page?.document_url)
  }, [FieldOfficer?.page?.target])

  function fetchData() {
    if (year && regionalId) {
      dispatch(getDetailTargetByYearTargetRegional(year, regionalId))
      dispatch(getDetailTargetByYearTargetSubRegional(year, regionalId))
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  function onChangeUpload(file) {
    dispatch(uploadAction({ data: file, type: UPLOAD.AVATAR }))
    setFileAttachments([file])
  }

  useEffect(() => {
    if (MasterData.urlResponseUpload) {
      setUrlDocument(MasterData.urlResponseUpload)
    }
    return () => {
      dispatch(resetUrlResponse())
    }
  }, [MasterData.urlResponseUpload])

  function checkDisableButtonRegional() {
    if (!formik.isValid || General?.loading) return true
    if (!formik.values.document_url) return true
    return false
  }

  async function onClickDownloadDocument() {
    if (documentUrl) {
      try {
        const response = await fetch(documentUrl)
        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob)

        const a = document.createElement("a")
        a.href = url
        a.download = "surat_referensi_perubahan_data_target_tanam"
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)

        window.URL.revokeObjectURL(url)
      } catch (error) {
        console.error("Error downloading the image:", error)
      }
    }
  }

  function onClickReset() {
    if (!FieldOfficer?.page?.target) return
    formik.setFieldValue("target", FieldOfficer?.page?.target)
    setTargetId(FieldOfficer?.page?.id)
    setDocumentUrl(FieldOfficer?.page?.document_url)
  }

  return {
    onClickReset,
    formik,
    onChangeUpload,
    urlDocument,
    fileAttachments,
    setFileAttachments,
    General,
    checkDisableButtonRegional,
    onClickDownloadDocument,
    setActiveStep,
    activeStep,
    labelStep,
    uiService,
    onSubmit,
    onRemoveFile
  }
}
